<template>
  <!-- 符合度百分比 -->
  <div class="precent">
    <!-- 符合度文字 -->
    <span
      class="position_text"
      :style="
      `left: ${parseInt((grade * 100).toFixed())}%; 
      transform: scale(0.9) translateX(-${parseInt((grade * 100).toFixed()) >= 50 ? 79 : 10}%);`
    ">
      符合度{{ parseInt((grade * 100).toFixed()) }}%
    </span>
    <!-- 符合度指针 -->
    <span
      class="position"
      :style="`left: ${parseInt((grade * 100).toFixed())}%`
    ">
    </span>
    <!-- 符合度线条 -->
    <div class="linear"/>
    <div class="precent_tip">
      <span>0% 仿品</span><span>100%&nbsp;&nbsp;正品</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'precent',
  props: {
    grade: {
      type: String
    }
  },
  mounted() {},
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.precent {
  position: relative;
  margin-top: 14%;
  .linear {
    width: 100%;
    height: 10px;
    background-color: #b3d9fc;
    background: linear-gradient(to right, #a1c4fd, #c2e9fb);
  }
  .position_text {
    width: 150px;
    position: absolute;
    top: -29 * 2px;
    transform: scale(0.8) translateX(-14%);
    font-weight: 500;
    font-size: 12 * 2px;
    line-height: 17 * 2px;
  }
  .position {
    width: 4px;
    height: 14px;
    position: absolute;
    transform: translateY(-18px);
    background-color: black;
  }
  .precent_tip {
    margin-top: 8 * 2px;
    display: flex;
    justify-content: space-between;
    font-size: 11 * 2px;
    line-height: 30px;
    color: #828393;
  }
}
</style>